var map = {
	"./en.bedrijfsdata.json": [
		3735,
		[
			735
		]
	],
	"./en.developers.json": [
		8071,
		[
			71
		]
	],
	"./nl.bedrijfsdata.json": [
		6756,
		[
			756
		]
	],
	"./nl.developers.json": [
		1046,
		[
			808
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(function() { return __webpack_require__.t(id, 3 | 16); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1341;
module.exports = webpackAsyncContext;